import { render, staticRenderFns } from "./PreciosProveedorComponent.vue?vue&type=template&id=bbe09bd4&"
import script from "./PreciosProveedorComponent.vue?vue&type=script&lang=js&"
export * from "./PreciosProveedorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports